export type ContactHandoffPath =
    | "sms_navigation"
    | "qr_fallback"
    | "session_missing";

export function getContactHandoffPath(input: {
    canUseSmsHandoff: boolean;
    smsUrl: string;
}): ContactHandoffPath {
    return input.canUseSmsHandoff && input.smsUrl.trim()
        ? "sms_navigation"
        : "qr_fallback";
}

export function smsHref(number: string, body: string) {
    return `sms:${number.replace(/[\s().-]/g, "")}?&body=${encodeURIComponent(body)}`;
}
